/* eslint-disable no-undef */
export const useModalStore = defineStore('modal', () => {
  const isAddToCartModalOpen = ref(false);
  const isLoginModalOpen = ref(false);
  const setIsAddToCartModalOpen = payload => {
    isAddToCartModalOpen.value = payload;
  };
  const setIsLoginModalOpen = payload => {
    isAddToCartModalOpen.value = payload;
  };
  return {
    isAddToCartModalOpen,
    setIsAddToCartModalOpen,
    isLoginModalOpen,
    setIsLoginModalOpen
  };
});